// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-16.1 — pantalla de clasificación del documento.
   Los valores (tamaños, colores, radios) son los del prototipo de Paula, para que lo que vea
   el cliente sea lo que ella enseñó. Todo acotado a .document-kind: el CSS de CRA es global. */

.document-kind {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px 60px;
}

.document-kind h1 {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 4px;
  color: #1b1b1b;
}

.document-kind-fichero {
  color: #666;
  font-size: 14px;
  margin: 0 0 20px;
}

/* Pasos */
.document-kind-pasos {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.document-kind-pasos li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  padding: 5px 14px 5px 6px;
}

.document-kind-pasos li.hecho { color: #333; }
.document-kind-pasos li.actual { color: #1b1b1b; }

.document-kind-paso-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e5e5e5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

.document-kind-pasos li.actual .document-kind-paso-num { background: #111; color: #fff; }
.document-kind-pasos li.hecho .document-kind-paso-num { background: #dff5e8; color: #157347; }

/* Documento a la izquierda, lo detectado a la derecha */
.document-kind-columnas {
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 16px;
  align-items: start;
}

.document-kind-previa {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.document-kind-previa embed,
.document-kind-previa img {
  display: block;
  width: 100%;
  height: 420px;
  object-fit: contain;
  border: none;
  background: #fff;
}

.document-kind-previa-vacia {
  height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
  background: #fafafa;
}

.document-kind-previa-pie {
  display: block;
  font-size: 12px;
  color: #666;
  padding: 7px 10px;
  border-top: 1px solid #eee;
}

/* Tarjetas */
.document-kind-tarjeta {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.document-kind-tarjeta h2 {
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 12px;
  color: #1b1b1b;
}

/* Campos detectados: el fondo azul claro significa "esto lo ha leído la IA" */
.document-kind-campo { margin-bottom: 12px; }

.document-kind-campo label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.document-kind-campo input {
  font: inherit;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 7px 9px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}

.document-kind-campo.detectado input { background: #f0f7ff; border-color: #9cc3f0; }

.document-kind-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  font-style: normal;
  color: #2563b0;
  background: #e4f0ff;
  border-radius: 8px;
  padding: 1px 7px;
  margin-left: 6px;
}

.document-kind-pista {
  font-size: 12.5px;
  color: #777;
  margin: -6px 0 12px;
}

.document-kind-leyendo {
  font-size: 13px;
  color: #666;
  background: #eef5ff;
  border: 1px solid #9cc3f0;
  border-radius: 8px;
  padding: 9px 12px;
  margin: 0 0 12px;
}

.document-kind-error {
  font-size: 13px;
  color: #5a2a00;
  background: #fff0e3;
  border-left: 4px solid #e46a00;
  border-radius: 0 6px 6px 0;
  padding: 9px 12px;
  margin: 0 0 12px;
}

/* La pregunta */
.document-kind-opciones {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.document-kind-opcion {
  background: #fff;
  border: 2px solid #ccc;
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  font: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.document-kind-opcion:hover:not(:disabled) { border-color: #111; background: #fafafa; }
.document-kind-opcion:disabled { opacity: 0.55; cursor: progress; }

.document-kind-opcion b { font-size: 16px; color: #1b1b1b; }
.document-kind-opcion span { font-size: 13px; color: #666; line-height: 1.45; }

/* Salidas secundarias */
.document-kind-pie {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 4px;
}

.document-kind-secundario {
  border: none;
  background: none;
  padding: 0;
  color: #2563b0;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}

.document-kind-secundario:hover { text-decoration: underline; }

@media (max-width: 900px) {
  .document-kind { padding: 20px 16px 40px; }
  .document-kind-columnas,
  .document-kind-opciones { grid-template-columns: 1fr; }
  .document-kind-previa embed,
  .document-kind-previa img { height: 300px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/DocumentKindStep.css"],"names":[],"mappings":"AAAA;;+FAE+F;;AAE/F;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gCAAgC,WAAW,EAAE;AAC7C,iCAAiC,cAAc,EAAE;;AAEjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,yDAAyD,gBAAgB,EAAE,WAAW,EAAE;AACxF,wDAAwD,mBAAmB,EAAE,cAAc,EAAE;;AAE7F,wDAAwD;AACxD;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8EAA8E;AAC9E,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnF;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,6CAA6C,kBAAkB,EAAE,mBAAmB,EAAE;AACtF,iCAAiC,aAAa,EAAE,gBAAgB,EAAE;;AAElE,0BAA0B,eAAe,EAAE,cAAc,EAAE;AAC3D,6BAA6B,eAAe,EAAE,WAAW,EAAE,iBAAiB,EAAE;;AAE9E,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA,kCAAkC,0BAA0B,EAAE;;AAE9D;EACE,iBAAiB,uBAAuB,EAAE;EAC1C;4BAC0B,0BAA0B,EAAE;EACtD;8BAC4B,aAAa,EAAE;AAC7C","sourcesContent":["/* LAKPED-16.1 — pantalla de clasificación del documento.\n   Los valores (tamaños, colores, radios) son los del prototipo de Paula, para que lo que vea\n   el cliente sea lo que ella enseñó. Todo acotado a .document-kind: el CSS de CRA es global. */\n\n.document-kind {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 28px 32px 60px;\n}\n\n.document-kind h1 {\n  font-size: 26px;\n  font-weight: 600;\n  margin: 0 0 4px;\n  color: #1b1b1b;\n}\n\n.document-kind-fichero {\n  color: #666;\n  font-size: 14px;\n  margin: 0 0 20px;\n}\n\n/* Pasos */\n.document-kind-pasos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.document-kind-pasos li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #888;\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 20px;\n  padding: 5px 14px 5px 6px;\n}\n\n.document-kind-pasos li.hecho { color: #333; }\n.document-kind-pasos li.actual { color: #1b1b1b; }\n\n.document-kind-paso-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #e5e5e5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n}\n\n.document-kind-pasos li.actual .document-kind-paso-num { background: #111; color: #fff; }\n.document-kind-pasos li.hecho .document-kind-paso-num { background: #dff5e8; color: #157347; }\n\n/* Documento a la izquierda, lo detectado a la derecha */\n.document-kind-columnas {\n  display: grid;\n  grid-template-columns: 1fr 1.3fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.document-kind-previa {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.document-kind-previa embed,\n.document-kind-previa img {\n  display: block;\n  width: 100%;\n  height: 420px;\n  object-fit: contain;\n  border: none;\n  background: #fff;\n}\n\n.document-kind-previa-vacia {\n  height: 420px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #999;\n  font-size: 13px;\n  background: #fafafa;\n}\n\n.document-kind-previa-pie {\n  display: block;\n  font-size: 12px;\n  color: #666;\n  padding: 7px 10px;\n  border-top: 1px solid #eee;\n}\n\n/* Tarjetas */\n.document-kind-tarjeta {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.document-kind-tarjeta h2 {\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0 0 12px;\n  color: #1b1b1b;\n}\n\n/* Campos detectados: el fondo azul claro significa \"esto lo ha leído la IA\" */\n.document-kind-campo { margin-bottom: 12px; }\n\n.document-kind-campo label {\n  display: block;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.document-kind-campo input {\n  font: inherit;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 7px 9px;\n  background: #fff;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.document-kind-campo.detectado input { background: #f0f7ff; border-color: #9cc3f0; }\n\n.document-kind-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  font-style: normal;\n  color: #2563b0;\n  background: #e4f0ff;\n  border-radius: 8px;\n  padding: 1px 7px;\n  margin-left: 6px;\n}\n\n.document-kind-pista {\n  font-size: 12.5px;\n  color: #777;\n  margin: -6px 0 12px;\n}\n\n.document-kind-leyendo {\n  font-size: 13px;\n  color: #666;\n  background: #eef5ff;\n  border: 1px solid #9cc3f0;\n  border-radius: 8px;\n  padding: 9px 12px;\n  margin: 0 0 12px;\n}\n\n.document-kind-error {\n  font-size: 13px;\n  color: #5a2a00;\n  background: #fff0e3;\n  border-left: 4px solid #e46a00;\n  border-radius: 0 6px 6px 0;\n  padding: 9px 12px;\n  margin: 0 0 12px;\n}\n\n/* La pregunta */\n.document-kind-opciones {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.document-kind-opcion {\n  background: #fff;\n  border: 2px solid #ccc;\n  border-radius: 12px;\n  padding: 20px;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.document-kind-opcion:hover:not(:disabled) { border-color: #111; background: #fafafa; }\n.document-kind-opcion:disabled { opacity: 0.55; cursor: progress; }\n\n.document-kind-opcion b { font-size: 16px; color: #1b1b1b; }\n.document-kind-opcion span { font-size: 13px; color: #666; line-height: 1.45; }\n\n/* Salidas secundarias */\n.document-kind-pie {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  margin-top: 4px;\n}\n\n.document-kind-secundario {\n  border: none;\n  background: none;\n  padding: 0;\n  color: #2563b0;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.document-kind-secundario:hover { text-decoration: underline; }\n\n@media (max-width: 900px) {\n  .document-kind { padding: 20px 16px 40px; }\n  .document-kind-columnas,\n  .document-kind-opciones { grid-template-columns: 1fr; }\n  .document-kind-previa embed,\n  .document-kind-previa img { height: 300px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
